export default "__VITE_ASSET__gsnCudKN__"